"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var LastCell_1 = __importDefault(require("atomicComponents/molecules/Table/LastCell"));
var hooks_1 = require("containers/ConfirmationModal/hooks");
var ServiceCell_1 = __importDefault(require("containers/MyStack/styles/ServiceCell"));
var analytics_1 = require("utils/analytics");
var hooks_2 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var SubtleTextField_1 = __importDefault(require("./styles/SubtleTextField"));
var TeamTableRow_1 = __importDefault(require("./styles/TeamTableRow"));
var AddTeam = function (_a) {
    var setAddTeam = _a.setAddTeam, isPartialView = _a.isPartialView;
    var _b = __read((0, react_1.useState)(null), 2), teamName = _b[0], setTeamName = _b[1];
    var _c = __read((0, hooks_2.useSubmitter)('company_teams'), 1), teamSubmitter = _c[0];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfile);
    var companyId = profile.companyId;
    var focusNewTeamInputField = react_1.default.createRef();
    var confirm = (0, hooks_1.useConfirm)();
    var track = (0, analytics_1.usePreparedTracker)('Add New Team');
    react_1.default.useEffect(function () {
        var _a;
        (_a = focusNewTeamInputField.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, []);
    var createNewTeam = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isDiscard;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!!teamName) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirm('Do you want to discard your changes?', '', 'red', 'Discard')];
                case 1:
                    isDiscard = _b.sent();
                    if (isDiscard) {
                        track({ source: 'Teams', action: 'Discard' });
                        setAddTeam(false);
                    }
                    else {
                        track({ source: 'Teams', action: 'Pending' });
                        (_a = focusNewTeamInputField.current) === null || _a === void 0 ? void 0 : _a.focus();
                    }
                    return [3 /*break*/, 3];
                case 2:
                    track({ source: 'Teams', action: 'Submit', value: teamName });
                    teamSubmitter({ name: teamName, companyId: companyId, headcount: 1 });
                    setAddTeam(false);
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsxs)(TeamTableRow_1.default, __assign({ isActive: true, style: { color: '#9CA9B0', cursor: 'default' }, hidden: isPartialView }, { children: [(0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 200, pl: 3, flex: "none" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ ml: -0.5, onClick: function (e) { return !isPartialView && e.stopPropagation(); } }, { children: (0, jsx_runtime_1.jsx)(SubtleTextField_1.default, { style: { justifyContent: 'left', width: '100%' }, placeholder: "Team Name", type: "text", onChange: function (e) { return setTeamName(e.target.value); }, onKeyPress: function (e) { return e.key === 'Enter' && createNewTeam(); }, onBlur: function () { return createNewTeam(); }, variant: 'standard', name: "teamName", value: teamName, inputRef: focusNewTeamInputField, InputProps: {
                            disableUnderline: true,
                            autoComplete: 'off',
                            inputProps: {
                                style: { textAlign: 'left' },
                            },
                        } }) })) })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ width: 125, pr: 3, textAlign: "right", flex: "none" }, { children: "$0" })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ pr: 4, textAlign: "right" }, { children: "0" })), (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ textAlign: "right" }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ justifyContent: "end", mr: -1 }, { children: (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ pr: 2.25 }, { children: "1" })) })) })), (0, jsx_runtime_1.jsx)(LastCell_1.default, {})] })));
};
exports.default = AddTeam;
